import { InputGroupField } from 'cwp-components/forms'
import React, { useEffect, useState } from 'react'
import { BsSearch } from 'react-icons/bs'

const SearchByLaw = ({ filteredTags, setTags, tags }: any) => {
  const [tagValue, setValue] = useState('')

  const handleTagSearchInputChange = (e: any) => {
    setValue(e.target.value)
  }

  useEffect(() => {
    setTags(tags.filter((tag) => tag.name.includes(tagValue)))
  }, [tagValue])

  return (
    <div className=''>
      <h2 className='md:text-[32px] text-[18px] max-sm:text-center  font-bold md:mb-[50px] mb-[24px] text-[#001A3D]'>
        Search by law
      </h2>
      <div className='relative mb-[24px]'>
        <InputGroupField
          Icon={BsSearch}
          reverse
          value={tagValue}
          placeholder='Search for a tag'
          onChange={handleTagSearchInputChange}
        />
      </div>
      <div className='flex flex-wrap md:gap-[16px] gap-[12px]'>
        {filteredTags.slice(0, 10).map((tag, idx: number) => (
          <span
            key={idx}
            className={`badge ${
              idx % 2 ? 'bg-[#E3FFFB]' : 'bg-[#EBEBFF]'
            } !text-[16px] max-sm:!text-[12px]`}
          >
            {tag.name}
          </span>
        ))}
      </div>
    </div>
  )
}

export default SearchByLaw
